import { Component, OnInit, ChangeDetectorRef, NgZone, ViewChild } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
//import { AngularFireDatabase } from 'angularfire2/database';
import { AuthService, DataService, HelperService } from '../../_services';
import * as _moment from 'moment';
@Component({
  selector: 'app-data-import',
  templateUrl: './data-import.component.html',
  styleUrls: ['./data-import.component.css'],
  //changeDetection: ChangeDetectionStrategy.Default
})
export class DataImportComponent implements OnInit {
  @ViewChild('csvReader', {static: false}) csvReader: any;
  
  constructor(
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    //public db: AngularFireDatabase,
    public svcAuth: AuthService,
    private svcData: DataService,
    private svcHelper: HelperService,
  ) { }
  
  records = []; csvRecords = []; recordsErr = [];
  pageData = {
    account: {
      fullName: '', email: 'admin', password: 'admin', confirmPassword: '', imageUrl: '', role: 'ADMIN', url: 'http://10.206.190.218:9000'
    },
    viewMode: 'UPLOAD',
    actionMode: 'NEW',
    userList: [],
    sHour:0, eHour: 23,
    countSuccess:0, countDone: 0, countPending:0, processDelay: 0
  };
  tAccount:any;
  roles = [
    {title: 'Admin', value: 'ADMIN'},
    {title: 'Normal', value: 'NORMAL'},
  ];
  roleSelected: any;
  isLoading: false;
  ngOnInit() {
    this.dataLoad();
  }
  dataLoad(){
    this.loading(true);
    this.svcData.userList().subscribe(res=>{
      this.loading(false);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.userList = res.data;
    });
  }
  dataLoadFirebase(){
    this.loading(true);
    //this.pageData.userList = [ {},{},{},{},{},{} ];
    // this.db.list('accounts').snapshotChanges().subscribe(res=>{
    //   this.loading(false);
    //   this.pageData.userList = [];
    //   res.forEach(resDetail=>{
    //     var _record:any = resDetail.payload.val();
    //     _record.key = resDetail.key;
    //     this.pageData.userList.push(_record);
    //   });
    // });
  }
  onSubmit(){
    var _hashPassword = this.svcHelper.hmac(this.pageData.account.password);
    //console.log(`Hash Passwod: ${_hashPassword}`);

    var _url = this.pageData.account.url + '/api/v1/login';
    var _arg = {
      'email': this.pageData.account.email,
      'password': _hashPassword
    };

    this.svcHelper.httpPost(_url, {}).subscribe(res=>{
      //console.log(res);
    });
    
  }
  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }
  roleSelect(arg){
    this.roleSelected = arg;
  }
  showAlert(msg){
    //alert(msg);
    M.toast({html: msg});
  }
  uploadFile($event){
    //console.log($event);
    this.csvRecords = [];
    let files = $event.srcElement.files;
    if (this.isValidCSVFile(files[0])) {
      let input = $event.target;  
      let reader = new FileReader();  
      reader.readAsText(input.files[0]);  
      reader.onload = () => {  
        let csvData = reader.result;  
        this.csvRecords = (<string>csvData).split(/\r\n|\n/);
      };
      reader.onerror = () => {  
        this.svcHelper.showAlert('error is occured while reading file!');  
      };
    } else {  
      this.svcHelper.showAlert("Please import valid .csv file.");  
      this.fileReset();
    }
  }
  readCsvRecords(){
    if(!this.isValidInput()) return;
    var _date = _moment('2000-1-1');
    this.records = []; this.recordsErr = [];
    var _noOfHour = this.pageData.eHour - this.pageData.sHour + 1;
    var _noOfColumn = (_noOfHour*2)+2;
    this.csvRecords.forEach(recCsv=>{
      var _arr = recCsv.split(',');
      //console.log(_arr.length);
      if(_arr.length!=_noOfColumn){
        this.recordsErr.push({text: recCsv, remark: 'No of column is not matching'});
        return;
      }
      if(_arr[1].length<1){
        this.recordsErr.push({text: recCsv, remark: 'Empty Sensor ID'});
        return;
      }
      var _sensorId = _arr[1];
      if(_arr[0].length>0){
        var _recDate = _moment(_arr[0]);
        if(!_recDate.isValid()){
          this.recordsErr.push({text:recCsv, remark:'Ignore Line'})
          return;
        }
        _date = _moment(_recDate.format('YYYY-MM-DD'));
      }
      if(_date.format('YYYY-MM-DD') == '2000-01-01'){
        this.recordsErr.push({text: recCsv, remark: 'No date specified'});
        return;
      }
      for(var i=2; i<_noOfColumn;){
        var _h = (i/2)-1;
        var _inValue = _arr[i];
        i++;
        var _outValue = _arr[i];
        this.records.push({
          timestamp:_date.format(`YYYY-MM-DD ${_h}:00`), sensorId: _arr[1], inValue:_inValue, outValue:_outValue
        });
        i++;
      }
    });

    this.pageData.viewMode = 'RECORDS';
  }
  importRecords(){
    if(this.records.length<1){
      this.svcHelper.showAlert('No record to import!');
      return;
    }
    this.pageData.viewMode = 'STATUS';
    this.pageData.countSuccess = 0;
    this.pageData.countDone = 0;
    this.importRecord();
    // this.records.forEach(async rec=>{
    //   this.importRecord(rec);
    //   await new Promise(r => setTimeout(r, 1000));
    // });
  }
  importRecord(){
    if(this.records.length<=this.pageData.countDone){
      this.svcHelper.showAlert('DONE!!!');
      return;
    }
    var rec = this.records[this.pageData.countDone];
    this.svcData.sensorDataImportHourly(rec.sensorId, _moment(rec.timestamp).format('YYYYMMDDHH0000'), rec.inValue, rec.outValue).subscribe(res=>{
      if(res.status != 'OK'){
        this.svcHelper.showAlert(res.message);
        return;
      }
      this.pageData.countSuccess++;
    });
    this.pageData.countDone++;
    this.pageData.countPending = this.pageData.countDone-this.pageData.countSuccess;
    this.pageData.processDelay = 200;
    if(this.pageData.countPending>1000) this.pageData.processDelay = 5000;
    else if(this.pageData.countPending>500) this.pageData.processDelay = 1000;
    else if(this.pageData.countPending>300) this.pageData.processDelay = 500;
    setTimeout(() => {
      this.importRecord();
    }, this.pageData.processDelay);
  }
  isValidInput():boolean{
    if(this.csvRecords.length < 1){
      this.svcHelper.showAlert('No record to import!');
      return false;
    }
    if(this.pageData.sHour<0 || this.pageData.sHour>23){
      this.svcHelper.showAlert('Invalid Start Hour!');
      return false;
    }
    if(this.pageData.eHour<0 || this.pageData.eHour>23){
      this.svcHelper.showAlert('Invalid End Hour!');
      return false;
    }
    if(this.pageData.sHour > this.pageData.eHour){
      this.svcHelper.showAlert('Start Hour should not be later than End Hour!');
      return false;
    }
    return true;
  }
  isValidCSVFile(file: any) {  
    return file.name.endsWith(".csv");  
  }
  fileReset() {  
    this.csvReader.nativeElement.value = "";  
    this.records = [];  
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
    this.pageData.actionMode = arg ? 'EDIT' : 'NEW';
    window.setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
    }, 500);

    if(this.pageData.actionMode == 'EDIT'){
      this.tAccount = arg;
      this.pageData.account.fullName = arg.fullName;
      this.pageData.account.email = arg.email;
      this.roles.forEach(r=>{
        //console.log(r.value + ' vs ' + arg.role);
        if(r.value == arg.role){
          this.roleSelected = r;
          //console.log(this.roleSelected);
        }
      });
    }
  }
  userDelete(arg){
    if(!confirm(`Are you sure you want to delete the user "${arg.fullName}"?`)) return;

    this.svcData.userDelete(arg).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.dataLoad();
      this.showAlert('User successfully deleted!');
    });
  }
  userList(){
    this.pageData.viewMode = 'LIST';
  }
  
}
